import styled from 'styled-components';
import { Box, Card } from '@mui/material';

export const ReviewsSection = styled(Box)`
  margin: 24px 0 0;
`;

export const ReviewsCard = styled(Card)`
  border-radius: 20px !important;
  border: 1px solid rgba(26, 26, 46, 0.07) !important;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(26, 26, 46, 0.04) !important;
`;

export const ReviewsHeader = styled(Box)`
  padding: 20px 22px;
  border-bottom: 1px solid rgba(26, 26, 46, 0.06);
`;

export const ReviewsTitle = styled.h2`
  margin: 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #1a1a2e;
`;

export const ReviewsSummary = styled.p`
  margin: 0;
  font-size: 0.94rem;
  color: #5a6478;
`;

export const ReviewsHeaderRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const SummaryLeft = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SummaryRight = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;

  .MuiChip-root {
    border-radius: 999px;
    font-weight: 700;
    color: #1a1a2e;
    background: rgba(1, 235, 178, 0.18);
  }

  .MuiRating-iconFilled,
  .MuiRating-iconHover {
    color: #01ebb2;
  }

  .MuiRating-iconEmpty {
    color: #d4d8e0;
  }
`;

export const ReviewRow = styled(Box)`
  padding: 14px 6px;
`;

export const AvatarBrand = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-weight: 800;
  color: #0d4efe;
  background: rgba(1, 235, 178, 0.18);
  border: 1px solid rgba(13, 78, 254, 0.12);
`;

export const NameAndMeta = styled(Box)`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
`;

export const RatingLine = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;

  .MuiRating-iconFilled,
  .MuiRating-iconHover {
    color: #01ebb2;
  }

  .MuiRating-iconEmpty {
    color: #d4d8e0;
  }
`;
